import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TOrdersApi } from './types';

export const orders: TOrdersApi = {
	getConfirmedOrders: (payload) =>
		http.post(endpoint.orders.LOAD_CONFIRMED_ORDERS, payload).then((response) => response.data),
	getOrderDetailsCombined: (payload) =>
		http
			.get(endpoint.orders.ORDER_DETAILS_COMBINED(payload.orderId))
			.then((response) => response.data),
	createOrderReturn: (payload) =>
		http.post(endpoint.orders.CREATE_ORDER_RETURN, payload).then((response) => response.data),
	createOrderDiscount: (payload) =>
		http.post(endpoint.orders.CRATE_ORDER_DISCOUNT, payload).then((response) => response.data),
	getVatAndEASFee: () =>
		http.get(endpoint.orders.LOAD_VAT_AND_EAS_FEE).then((response) => response.data),
};
